export default {
  jobs:[],
  available: []
};
